module.exports = __webpack_public_path__ + "static/Grupo 76-7200ee09fc157f7b4aa7a06ee7f1024e.svg";